import FileSaver from "file-saver";
import { restClient } from "./raftApi";

/**
 * Helpers for downloading SDS files from the REST API.
 */
const ChemtrackerSdsHelper = {
  /**
   * Downloads an SDS file.
   *
   * @param {string} provider - The SDS provider.
   * @param {string} sdsDocumentId - The SDS document ID.
   * @param {string} url - The URL to download the file from.
   * @return {Promise} - A promise that resolves when the file is downloaded.
   */
  async sdsDownloadFile(provider, sdsDocumentId, url = "") {
    if (!url) {
      url = `raft/rest/chemtracker-sds-pdf-download/${provider}/${sdsDocumentId}?_format=json`;
    }

    try {
      const response = await restClient.downloadFileFullResponse(url);
      const filename =
        this.getFilenameFromDisposition(
          response.headers["content-disposition"],
        ) || `SDS-Doc-${sdsDocumentId}.pdf`;
      FileSaver.saveAs(new Blob([response.data]), filename);
    } catch (err) {
      // eslint-disable-next-line
      console.error(`Error downloading SDS file: ${err}`);
    }
  },

  /**
   * Extracts the filename from the Content-Disposition header.
   *
   * @param {string} disposition - The Content-Disposition header.
   * @return {string} - The filename, or null if it cannot be extracted.
   */
  getFilenameFromDisposition(disposition) {
    const filenameRegex = /filename=("?)([^";\n]+)\1/;
    const matches = filenameRegex.exec(disposition);
    return matches ? matches[2] : null;
  },
};

export default ChemtrackerSdsHelper;
